export enum ArticleTag {
  Dev = 'dev',
  Ux = 'ux',
  Ui = 'ui',
  Po = 'po',
  Other = 'other',
  All = 'all',
}
